import { useCallback, useState } from "react";
import client from "../client";
import handleApiError from "../../hooks/handleApiError";
import { handleToast } from "../../utils/functions";

export default function useCreateStudentReportCard() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (payload) => {
    try {
      const { data } = await client.post(`/result/reportcard/new`, payload);
      setLoading(false);

      handleToast(data?.message);
      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return [request, loading];
}
